<template>
    <div class="ShareBar">
        <div class="ShareBar-container">
            <div class="ShareBar-icons">
                <div :index="index" :key="network.network" v-for="(network, index) in socials">
                    <a :class="'ShareBar-button_' + network.network" :href="network.link" :target="network.target"
                            :title="network.description" @click.prevent.stop="openShareLink(network)"
                            class="custom-ShareBar-button ShareBar-button">
                        <iconEmail :class="'ShareBar-icon_' + network.network" class="custom-ShareBar-icon ShareBar-icon"
                                v-if="network.network === 'email'" />
                        <iconLinkedIn :class="'ShareBar-icon_' + network.network" class="custom-ShareBar-icon ShareBar-icon"
                                v-if="network.network === 'linkedin'" />
                        <iconTwitter :class="'ShareBar-icon_' + network.network" class="custom-ShareBar-icon ShareBar-icon"
                                v-if="network.network === 'twitter'" />
                    </a>
                </div>
            </div>
        </div>
        <div class="Dev">
            <div class="Dev-container" v-if="this.$store.state.showDebug">
                <ul class="Dev-list">
                    <li>isTargeted: <b>{{this.$store.state.consumer.isTargeted}}</b></li>
                    <li>relmKey: <b>{{this.$store.state.consumer.relmKey}}</b></li>
                    <li>sharedKey: <b>{{this.$store.state.consumer.sharedKey}}</b></li>
                    <li>step: <b>{{this.$store.state.consumer.step}}</b></li>
                    <li>doNotTrack: <b>{{this.$store.state.keenInfos.doNotTrack}}</b></li>
                    <li>hidden: <b>{{this.$store.state.keenInfos.hidden}}</b></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    //import router from '@/router'
    import store from '@/store';
    import iconEmail from '@/icons/envelope.svg';
    import iconLinkedIn from '@/icons/linkedin.svg';
    import iconTwitter from '@/icons/twitter.svg';

    export default {
        name: 'ShareContent',
        components: {
            'debugArticleDisplay': () => import('@/components/debugArticleDisplay'),
            iconEmail,
            iconLinkedIn,
            iconTwitter
        },
        computed: {
            dataLoaded() {
                return store.state.loaded;
            },
            socials: () => {
                return store.state.socialSharing;
            }
        },
        mounted() {
            this.eventInit();
        },
        methods: {
            openShareLink: (network) => {
                let pageUrl = document.querySelector('meta[property=\'og:url\']').getAttribute('content');
                let pageTitle = document.querySelector('meta[property=\'og:title\']').getAttribute('content');

                let currentUrl = network.link.replace(/TITLE/g, encodeURI(pageTitle));
                currentUrl = currentUrl.replace(/URL/g, pageUrl + '?sharedOn=' + network.network);

                let windowWidth = (Number.isInteger(network.windowWidth)) ? network.windowWidth : screen.width;
                let windowHeight = (Number.isInteger(network.windowHeight)) ? network.windowHeight : screen.height;

                if (network.target) {
                    window.open(currentUrl, network.target);
                } else {
                    let params = 'left=' + (screen.width * .5 - windowWidth * .5) + ',top=' + (screen.height * .5 - windowHeight * .5) + ',menubar=no,toolbar=no,resizable=yes,scrollbars=no,height=' + windowHeight + ',width=' + windowWidth;
                    // console.log(currentUrl, pageTitle, params)
                    window.open(currentUrl, pageTitle, params);
                }
                return false;
            },
            eventOver: (el) => {
                el.currentTarget.classList.add('custom-ShareBar-icon_hover', 'ShareBar-icon_hover');
            },
            eventOut: (el) => {
                el.currentTarget.classList.remove('custom-ShareBar-icon_hover', 'ShareBar-icon_hover');
            },
            eventInit() {
                let vm = this;
                let elMain = document.getElementsByClassName('ShareBar-icons')[0];
                if (elMain !== undefined) {
                    elMain.querySelectorAll('a .ShareBar-icon').forEach((el) => {
                        el.addEventListener('mouseover', vm.eventOver);
                        el.addEventListener('mousemove', vm.eventOver);
                        el.addEventListener('mouseout', vm.eventOut);
                    });
                }
            }
        }
    };
</script>
